import { IonButton, IonCol, IonGrid, IonImg, IonPage, IonRow, IonText } from '@ionic/react';
import { useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router';

import Toolbar2 from '../../layouts/Toolbar2';
import BackAppButton from './BackAppButton';

import './Failed.css'

interface Props extends RouteComponentProps<{
  is_app?: string
}> { }

const Failed: React.FC<Props> = ({ match }) => {
  const bgWidth = 582;
  const bgHeight = 569;
  const initDeerWidth = 213;
  const initDeerHeight = 600;

  const [deerSize, setDeerSize] = useState({
    width: "",
    height: "",
    left: "",
    top: ""
  });

  useEffect(() => {
    const winWidth = window.innerWidth

    let bgWinRatio = winWidth / bgWidth

    let finalBgWidth = bgWidth * bgWinRatio
    let finalBgHeight = bgHeight * bgWinRatio

    let deerWidth = (initDeerWidth * bgWinRatio) / 1.3
    let deerHeight = (initDeerHeight * bgWinRatio) / 1.3

    let left = (finalBgWidth - deerWidth) / 2
    let top = (finalBgHeight - deerHeight) / 1.3

    setDeerSize({
      width: deerWidth + "px",
      height: deerHeight + "px",
      left: left + "px",
      top: top + "px"
    })
  }, [])

  return <IonPage className="failed-payment">
    {match.params.is_app != "1" ?
      <Toolbar2 hasBackButton transparent /> : null}

    <IonGrid>
      <IonRow>
        <IonCol>
          <IonImg className="bg" src="/assets/images/payment/nature_bg.svg" />
          <div className="deer" style={{ left: deerSize.left, top: deerSize.top, width: deerSize.width, height: deerSize.height }}></div>
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol className="content">
          <IonText>متاسفانه پرداخت شما موفقیت آمیز نبود!</IonText>
        </IonCol>
      </IonRow>
      {match.params.is_app == "1" ?
        <div className="ion-text-center">
          <BackAppButton doOnClick="open" />
        </div>
        : null}
    </IonGrid>
  </IonPage>
}

export default Failed